/**
 * Dashboard metadata for navigation pages
 * Contains title, description, route and chart count for each dashboard
 */

import { getDashboardIcon } from './icons';

export const forwardDashboards = [
  {
    id: 'oil',
    title: 'dashboard_titles.oil',
    description: 'dashboard_descriptions.oil',
    icon: getDashboardIcon('forward', 'oil'),
    route: '/reports/forward/oil',
    chartCount: 3,
  },
  {
    id: 'coal',
    title: 'dashboard_titles.coal',
    description: 'dashboard_descriptions.coal',
    icon: getDashboardIcon('forward', 'coal'),
    route: '/reports/forward/coal',
    chartCount: 3,
  },
  {
    id: 'emissions',
    title: 'dashboard_titles.emissions',
    description: 'dashboard_descriptions.emissions',
    icon: getDashboardIcon('forward', 'emissions'),
    route: '/reports/forward/emissions',
    chartCount: 3,
  },
  {
    id: 'gas',
    title: 'dashboard_titles.gas',
    description: 'dashboard_descriptions.gas',
    icon: getDashboardIcon('forward', 'gas'),
    route: '/reports/forward/gas',
    chartCount: 12,
  },
  {
    id: 'electricity',
    title: 'dashboard_titles.electricity',
    description: 'dashboard_descriptions.electricity',
    icon: getDashboardIcon('forward', 'electricity'),
    route: '/reports/forward/electricity',
    chartCount: 8,
  },
];

export const flexDashboards = [
  {
    id: 'crossborder',
    title: 'dashboard_titles.crossborder',
    description: 'dashboard_descriptions.crossborder',
    icon: getDashboardIcon('flex', 'crossborder'),
    route: '/reports/flexibility/crossborder',
    chartCount: 4,
  },
  {
    id: 'imbalance',
    title: 'dashboard_titles.imbalance',
    description: 'dashboard_descriptions.imbalance',
    icon: getDashboardIcon('flex', 'imbalance'),
    route: '/reports/flexibility/imbalance',
    chartCount: 10,
  },
  {
    id: 'intraday',
    title: 'dashboard_titles.intraday',
    description: 'dashboard_descriptions.intraday',
    icon: getDashboardIcon('flex', 'intraday'),
    route: '/reports/flexibility/intraday',
    chartCount: 3,
  },
  {
    id: 'dayAhead',
    title: 'dashboard_titles.day_ahead',
    description: 'dashboard_descriptions.day_ahead',
    icon: getDashboardIcon('flex', 'dayAhead'),
    route: '/reports/flexibility/dayAhead',
    chartCount: 5,
  },
  {
    id: 'fcr',
    title: 'dashboard_titles.fcr',
    description: 'dashboard_descriptions.fcr',
    icon: getDashboardIcon('flex', 'fcr'),
    route: '/reports/flexibility/fcr',
    chartCount: 5,
  },
  {
    id: 'afrr',
    title: 'dashboard_titles.afrr',
    description: 'dashboard_descriptions.afrr',
    icon: getDashboardIcon('flex', 'afrr'),
    route: '/reports/flexibility/afrr',
    chartCount: 6,
  },
  {
    id: 'mfrr',
    title: 'dashboard_titles.mfrr',
    description: 'dashboard_descriptions.mfrr',
    icon: getDashboardIcon('flex', 'mfrr'),
    route: '/reports/flexibility/mfrr',
    chartCount: 4,
  },
  {
    id: 'balancing',
    title: 'dashboard_titles.balancing',
    description: 'dashboard_descriptions.balancing',
    icon: getDashboardIcon('flex', 'balancing'),
    route: '/reports/flexibility/balancing',
    chartCount: 2,
  },
  {
    id: 'capturePrice',
    title: 'dashboard_titles.capture_price',
    description: 'dashboard_descriptions.capture_price',
    icon: getDashboardIcon('flex', 'capturePrice'),
    route: '/reports/flexibility/capturePrice',
    chartCount: 1,
  },
  {
    id: 'generation',
    title: 'dashboard_titles.generation',
    description: 'dashboard_descriptions.generation',
    icon: getDashboardIcon('flex', 'generation'),
    route: '/reports/flexibility/generation',
    chartCount: 1,
  },
  {
    id: 'tbSpreads',
    title: 'dashboard_titles.tb_spreads',
    description: 'dashboard_descriptions.tb_spreads',
    icon: getDashboardIcon('flex', 'tbSpreads'),
    route: '/reports/flexibility/tbSpreads',
    chartCount: 3,
  },
  {
    id: 'cbmp',
    title: 'dashboard_titles.cbmp',
    description: 'dashboard_descriptions.cbmp',
    icon: getDashboardIcon('flex', 'cbmp'),
    route: '/reports/flexibility/cbmp',
    chartCount: 2,
  },
  {
    id: 'congestion',
    title: 'dashboard_titles.congestion',
    description: 'dashboard_descriptions.congestion',
    icon: getDashboardIcon('flex', 'congestion'),
    route: '/reports/flexibility/congestion',
    chartCount: 6,
  },
];
